export default {
  placeholder: 'Zoeken',
  cancel: 'Annuleren',
};
